import { useEffect } from "react";

export const SplitDescription: React.FC = () => {

  useEffect(() => {
    const { hash } = window.location;
    let timeoutId: ReturnType<typeof setTimeout>;

    if (hash) {
      const el = document.querySelector(hash);

      if (el) {
        timeoutId = setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
      }
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="text parbase section">
      <span id="split" className="rte-standard">
        <b>Покупка товаров в Лемана ПРО в Сплит</b>
      </span>
      <p>
        <span className="rte-standard">
          Во всех магазинах Лемана ПРО на весь ассортимент товаров доступны сервисы Яндекса для оплаты
          частями Сплит. В интернет-магазине оплата Сплитом не доступна при покупке товаров категории "Строительные материалы" и товаров партнеров.
        </span>
      </p>
      <p>
        <b>Выберите выгодное условия для покупок</b>
      </p>

      <table className="kredit-table">
        <tr>
          <th></th>
          <td>
            <strong>Информация о Сплите</strong>
          </td>
        </tr>
        <tr>
          <th>Описание</th>
          <td>Сервис, позволяющий оплатить покупку частями.</td>
        </tr>
        <tr className="row-alt">
          <th>Срок оформления</th>
          <td>2-6 месяцев</td>
        </tr>
        <tr>
          <th>Сумма оформления</th>
          <td>До 150&nbsp;000 рублей</td>
        </tr>
        <tr className="row-alt">
          <th>
            Порядок выплат и диапазон значений полной стоимости услуги оплаты частями
          </th>
          <td>
            <p>
              <strong>на 2 месяца</strong>
            </p>
            <ul className="kredit-list">
              <li>4 платежа по 25%</li>
              <li>переплата 0 рублей</li>
            </ul>
            <p>
              <strong>на 4 месяца</strong>
            </p>
            <ul className="kredit-list">
              <li>4 платежа по 25%</li>
              <li>
                переплата рассчитывается индивидуально в зависимости от стоимости и рейтинга пользователя
              </li>
            </ul>
            <p>
              <strong>на 6 месяцев</strong>
            </p>
            <ul className="kredit-list">
              <li>6 платежей по 16,7%</li>
              <li>
                переплата рассчитывается индивидуально в зависимости от стоимости и рейтинга пользователя
              </li>
            </ul>
          </td>
        </tr>
      </table>
      <p>&nbsp;</p>
      <p>
        <span className="rte-standard">
          <b>Необходимые документы:</b>
        </span>
      </p>
      <table className="kredit-table">
        <tr>
          <td>
            <strong>Информация о Сплите</strong>
          </td>
        </tr>
        <tr>
          <td>
            Для оформления нужен только аккаунт в Яндекс ID, привязанный к российскому телефону.
          </td>
        </tr>
      </table>
      <p>&nbsp;</p>
      <p>
        <span className="rte-standard"><b>Требования к физическому лицу для оформления продукта «Сплит»</b></span>
      </p>
      <p>
        <span className="rte-standard">Гражданин Российской Федерации в возрасте от 18 лет</span>
      </p>
      <p>
        <span className="rte-standard"><b>Способы погашения Сплита:</b></span>
      </p>
      <p>
        <ul>
          <li><span className="rte-standard">Платежи списываются автоматически с карты, привязанной при оформлении Сплита. За несколько дней до списания приходит уведомление с напоминанием о платеже и его сумме.</span></li>
          <li><span className="rte-standard">Карту можно изменить в приложении Яндекс Пэй или в веб-версии (<a target="_blank" href="https://bank.yandex.ru/pay/split">split.yandex.ru</a>).</span></li>
        </ul>
      </p>
      <p>
        <span className="rte-standard"><b>Важно:</b></span>
      </p>
      <p>
        <ol>
          <li><span className="rte-standard">Сплит можно <b>погасить</b> частично или полностью <b>досрочно</b> в любой момент в течение срока договора без дополнительных комиссий.</span></li>
          <li><span className="rte-standard">Товар, приобретённый через Яндекс Сплит, можно <b>вернуть</b> в соответствии с условиями <a href="/service/vozvrat-tovara/">возврата</a> и обмена товара.</span></li>
          <li><span className="rte-standard">За рассмотрение заявления на выдачу Сплита <b>комиссия не взимается</b>. Рассмотрения заявки по продукту Сплит занимает от 1-й минуты и не более 1-го дня с момента предоставления физическим лицом заявки.</span></li>
          <li><span className="rte-standard">В Сплит можно купить не только выбранный товар, но и заказать услугу по его <b>установке и доставке</b>.</span></li>
          <li><span className="rte-standard">Если заказ больше, чем можно оплатить со Сплитом, разница добавляется к <b>первому платежу Яндекс Сплита</b>.</span></li>
        </ol>
      </p>
      <p>
        <span className="rte-standard">Сервис Яндекс Сплит предоставляется ООО “Финансовые и платежные технологии” (ОГРН 1237700813844, 115035, г. Москва, ул. Садовническая, д. 82, стр. 2). Оформление заказа осуществляется в соответствии с договором поручения, есть ограничения на использование сервиса. Подробная информация на сайте split.yandex.ru.</span>
      </p>
      <p>
        <span className="rte-standard">Информация по продукту Сплит, указанная на данной странице, предоставлена: ООО “Финансовые и платежные технологии” (ОГРН 1237700813844, ИНН 9705212635)</span>
      </p>
    </div>
  );
};
